import { render, staticRenderFns } from "./wxworkanalysis.vue?vue&type=template&id=516f9717&scoped=true&"
import script from "./wxworkanalysis.vue?vue&type=script&lang=js&"
export * from "./wxworkanalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516f9717",
  null
  
)

export default component.exports